import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-delivery-term-langs',
  templateUrl: './delivery-term-langs.component.html',
  styleUrls: ['./delivery-term-langs.component.css']
})
export class DeliveryTermLangsComponent implements OnInit {
    deliveryTermNo;

    public inputListLanguages: InputLanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.deliveryTermNo = this.stateService.getStateParams()['deliveryterm_no'];
    }

    private async loadLanguages() {
        if (!!this.deliveryTermNo) {
            this.inputListLanguages = await this.datatask.Post(1534, { deliveryterm_no: this.deliveryTermNo });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1535, { records: this.inputListLanguages }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface InputLanguageItem {
    deliveryterm_no: number;
    deliveryterm_lang_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('deliveryTermLangs', {
//        templateUrl: 'views/components/views/deliveryTermLangs/deliveryTermLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'deliveryTermLangsService', function ($stateParams, stateService, translateService, modalService, deliveryTermLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let deliveryTermNo = $stateParams.deliveryterm_no;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadLanguages() {
//                vm.model.inputListLanguages = (await deliveryTermLangsService.listLanguages({ deliveryterm_no: deliveryTermNo }));
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                deliveryTermLangsService.saveObj({ records: vm.model.inputListLanguages }).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadLanguages();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
